// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.offer-container {
  margin-bottom: 0.5rem;
}

.custom-bonus-box {
  margin-top: 5px;
  border: 1px solid #dddddd;
}
.custom-bonus-box ion-input {
  background-color: var(--ion-color-light-tint);
  border-color: #ebebeb;
}
.custom-bonus-box ion-button {
  height: 40px;
  width: 90px;
}
.custom-bonus-box .wrapper {
  min-height: 90px;
}

.ion-text-right {
  display: flex;
  flex-direction: row;
}

.promo-code {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}
.promo-code .left {
  width: 50%;
}
.promo-code .right {
  width: 50%;
  display: flex;
  align-items: center;
  padding-left: 10px;
}
.promo-code .right ion-icon {
  padding: 0 10px;
  font-size: 1.6rem;
}

.info-icon:hover {
  cursor: pointer;
}

.message-box {
  display: none;
  margin: 0 !important;
  border: 1px solid #808080 !important;
  border-style: solid !important;
}

.message-box-visible {
  display: block;
  z-index: 1;
  border: 1px solid grey !important;
  box-shadow: 0px 0.46rem 2.18rem rgba(4, 9, 20, 0.03), 0px 0.93rem 1.4rem rgba(4, 9, 20, 0.03), 0px 0.25rem 0.53rem rgba(4, 9, 20, 0.05), 0px 0.12rem 0.18rem rgba(4, 9, 20, 0.03);
  font-size: 1.2rem;
  color: #333;
  font-weight: 500;
}

.danger-checkbox {
  --background-checked: red;
  --border-color-checked: red;
}

.close-button {
  margin-top: -4.5%;
  margin-right: -2.5%;
}
@media screen and (max-width: 430px) {
  .close-button {
    margin-top: -11%;
  }
}
@media screen and (max-width: 353px) {
  .close-button {
    margin-top: -20%;
  }
}
@media screen and (max-width: 295px) {
  .close-button {
    margin-top: -31%;
  }
}
@media screen and (max-width: 245px) {
  .close-button {
    margin-top: -58%;
  }
}

.dial-one-plus {
  margin-right: 8px;
}

.phone-input-container {
  display: flex;
  align-items: center;
  width: 100%;
}

.country-code {
  padding: 12px;
  font-size: 16px;
  border-left: 1px solid #C2C2C2;
  border-top: 1px solid #C2C2C2;
  border-bottom: 1px solid #C2C2C2;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.underline-text {
  text-decoration: underline;
  text-decoration-color: blue;
}

.ios-checkbox ion-checkbox::part(container) {
  border-radius: 6px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/signup-step-one/signup-step-one.component.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;AACJ;;AAEA;EACI,eAAA;EACA,yBAAA;AACJ;AACI;EACI,6CAAA;EACA,qBAAA;AACR;AAEI;EAEI,YAAA;EACA,WAAA;AADR;AAII;EACI,gBAAA;AAFR;;AAMA;EACI,aAAA;EACA,mBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;AAHJ;AAKI;EACI,UAAA;AAHR;AAMI;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAJR;AAKQ;EACI,eAAA;EACA,iBAAA;AAHZ;;AASA;EACI,eAAA;AANJ;;AASA;EACI,aAAA;EACA,oBAAA;EACA,oCAAA;EACA,8BAAA;AANJ;;AAQA;EACI,cAAA;EACA,UAAA;EACA,iCAAA;EACA,iLAAA;EAIA,iBAAA;EACA,WAAA;EACA,gBAAA;AARJ;;AAWA;EACI,yBAAA;EACA,2BAAA;AARJ;;AAWA;EACE,iBAAA;EACA,mBAAA;AARF;AASE;EAHF;IAIE,gBAAA;EANA;AACF;AAOE;EANF;IAOE,gBAAA;EAJA;AACF;AAKE;EATF;IAUE,gBAAA;EAFA;AACF;AAGE;EAZF;IAaE,gBAAA;EAAA;AACF;;AAqBA;EACI,iBAAA;AAlBJ;;AA6CA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;AA1CJ;;AA6CE;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,6BAAA;EACA,gCAAA;EACA,2BAAA;EACA,8BAAA;AA1CJ;;AA6CE;EACE,0BAAA;EACA,2BAAA;AA1CJ;;AA4CA;EACI,kBAAA;AAzCJ","sourcesContent":[".offer-container{\n    margin-bottom: .5rem;\n}\n\n.custom-bonus-box {\n    margin-top: 5px;\n    border: 1px solid #dddddd;\n\n    ion-input {\n        background-color: var(--ion-color-light-tint);\n        border-color: #ebebeb;\n    }\n\n    ion-button {\n        // transform: translate(0, 27px);\n        height: 40px;\n        width: 90px;\n    }\n\n    .wrapper {\n        min-height: 90px;\n    }\n}\n\n.ion-text-right {\n    display: flex;\n    flex-direction: row;\n}\n\n.promo-code {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    justify-content: space-between;\n\n    .left {\n        width: 50%;\n    }\n\n    .right {\n        width: 50%;\n        display: flex;\n        align-items: center;\n        padding-left: 10px;\n        ion-icon {\n            padding: 0 10px;\n            font-size: 1.6rem;\n            // transform: translate(0px, 35px);\n        }\n    }\n}\n\n.info-icon:hover {\n    cursor: pointer;\n}\n\n.message-box {\n    display: none;\n    margin: 0 !important;\n    border: 1px solid #808080 !important;\n    border-style: solid !important;\n}\n.message-box-visible {\n    display: block;\n    z-index: 1;\n    border: 1px solid grey !important;\n    box-shadow: 0px 0.46rem 2.18rem rgba(4, 9, 20, 0.03),\n                0px 0.93rem 1.4rem rgba(4, 9, 20, 0.03),\n                0px 0.25rem 0.53rem rgba(4, 9, 20, 0.05),\n                0px 0.12rem 0.18rem rgba(4, 9, 20, 0.03);\n    font-size: 1.2rem;\n    color: #333;\n    font-weight: 500;\n}\n\n.danger-checkbox {\n    --background-checked: red;\n    --border-color-checked: red;\n    }\n\n.close-button {\n  margin-top: -4.5%;\n  margin-right: -2.5%;\n  @media screen and (max-width: 430px) {\n  margin-top: -11%;\n  }\n  @media screen and (max-width: 353px) {\n  margin-top: -20%;\n  }\n  @media screen and (max-width: 295px) {\n  margin-top: -31%;\n  }\n  @media screen and (max-width: 245px) {\n  margin-top: -58%;\n  }\n}\n\n// ion-item.custom-item {\n//     --background: #f0f0f0; /* Set the background color for the input item */\n//     border-radius: 8px; /* Optional: for rounded corners */\n//     ion-label {\n//         margin-left: 10px;\n//     }\n//   }\n\n//   ion-input.custom-input-floating {\n//     margin-top: 2px;\n//     --background: #ffffff; /* Set the background color for the input */\n//     --padding-start: 8px;\n//     --padding-end: 8px;\n//     --padding-top: 8px;\n//     --padding-bottom: 8px;\n//     border-radius: 4px; /* Optional: for rounded corners */\n//   }\n\n.dial-one-plus {\n    margin-right: 8px;\n  }\n// ion-input[type=\"text\"].ng-dirty.ng-invalid.ng-touched,\n// ion-input[type=\"email\"].ng-dirty.ng-invalid.ng-touched,\n// ion-input[type=\"password\"].ng-dirty.ng-invalid.ng-touched {\n\n//     margin-top: 2px;\n//     background-color: #ffdadc !important;\n//     box-shadow: none !important;\n//     border: none !important;\n\n// }\n\n// .custom-error-input.ng-dirty.ng-invalid.ng-touched  {\n//     margin-top: 2px;\n//     background-color: #ffdadc !important;\n//     box-shadow: none !important;\n//     border: none !important;\n// }\n//   ion-item.custom-item.ion-dirty.ion-invalid.ion-touched {\n//       --background :  #ffdadc !important;\n//     background-color: #ffdadc !important;\n//     box-shadow: inset 0 0 0 3px rgba(250, 0, 21, 0.15) !important;\n//     border: 1px solid #e1464e !important;\n// }\n\n\n.phone-input-container {\n    display: flex;\n    align-items: center;\n    width: 100%;\n  }\n\n  .country-code {\n    padding: 12px;\n    font-size: 16px;\n    border-left: 1px solid #C2C2C2;\n    border-top: 1px solid #C2C2C2;\n    border-bottom: 1px solid #C2C2C2;\n    border-top-left-radius: 4px ;\n    border-bottom-left-radius: 4px;\n    // margin-right: 8px;\n  }\n  .underline-text {\n    text-decoration: underline;\n    text-decoration-color:blue;\n  }\n.ios-checkbox ion-checkbox::part(container) {\n    border-radius: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
